import { useEffect } from 'react';
import clientSocket from '@/services/clientSocket';

const useSocket = (callback: Function, countCallback: Function) => {

  useEffect(() => {
    clientSocket.initChat(callback, countCallback);

    return () => {
      if (clientSocket) clientSocket.close();
    }
  }, []);

  return {};
}

export default useSocket;